import { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getFirestore } from "../../config/firebase";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import Loading from "../Loading/Loading";

function getBannerItems(banners, routeTipo, isDesktop) {
  if (!banners[0]) return [];
  const items = banners[0][isDesktop ? "desktop" : "mobile"] || [];

  if (routeTipo === "todos") return items;
  if (routeTipo === "plan") {
    const filtered = items.filter((b) => b.plan === true);
    return filtered.length > 0 ? filtered : items;
  }
  if (routeTipo === "convencional") {
    const filtered = items.filter((b) => b.convencional === true);
    return filtered.length > 0 ? filtered : items;
  }
  return items;
}

const Slider = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const { tipo } = useParams();
  const { openConsultaForm } = useWhatsAppConsulta();
  const routeTipo = tipo || "todos";
  const showSlider = routeTipo === "todos" || routeTipo === "plan" || routeTipo === "convencional";

  useEffect(() => {
    const obtenerDatos = async () => {
      const datosLocales = sessionStorage.getItem("sliders-fiat");
      if (datosLocales) {
        setBanners(JSON.parse(datosLocales));
        setLoading(false);
      } else {
        const db = getFirestore();
        try {
          const data = await db.collection("sliders-fiat").get();
          const arrayData = data.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          sessionStorage.setItem("sliders-fiat", JSON.stringify(arrayData));
          setBanners(arrayData);
        } catch (error) {
          console.error("Error al obtener datos de Firestore: ", error);
        } finally {
          setLoading(false);
        }
      }
    };

    obtenerDatos();
  }, []);

  const handleSlideChange = (selectedIndex, bannerArray, screen, type) => {
    if (window.dataLayer) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_promotion",
        ecommerce: {
          items: [
            {
              item_name: `URL:${bannerArray[selectedIndex]?.slider}` || "N/A",
              item_id: bannerArray[selectedIndex]?.id || "N/A",
              promotion_id: "N/A",
              promotion_name: `${type}`,
              creative_name: bannerArray[selectedIndex]?.creative_name || "N/A",
              creative_slot: `slider_${selectedIndex + 1}_${screen}`,
              location_id: "top_body_home",
            },
          ],
        },
      });
    }
  };

  const handleSliderClick = (item, index, screen, type) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "consultar",
      seccion: "slider",
      promotion_name: type,
      creative_name: item?.creative_name,
      creative_slot: `slider_${index + 1}_${screen}`,
    });
    openConsultaForm();
  };

  const renderCarousel = (items, screen, type) => (
    <Carousel onSlide={(index) => handleSlideChange(index, items, screen, type)}>
      {items.map((item, index) => (
        <Carousel.Item key={index}>
          <img
            className="d-block w-100 img-fluid slider-banner-img"
            src={item.slider}
            alt="Montironi Fiat"
            onClick={() => handleSliderClick(item, index, screen, type)}
            role="presentation"
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );

  if (loading) {
    return <Loading styles="mt-5 pt-5 pb-5" />;
  }

  if (!showSlider) {
    return <div id="inicio" />;
  }

  const desktopItems = getBannerItems(banners, routeTipo, true);
  const mobileItems = getBannerItems(banners, routeTipo, false);

  return (
    <div id="inicio">
      {desktopItems.length > 0 && (
        <div className="d-md-block d-none">{renderCarousel(desktopItems, "desktop", routeTipo)}</div>
      )}
      {mobileItems.length > 0 && (
        <div className="d-md-none d-block">{renderCarousel(mobileItems, "mobile", routeTipo)}</div>
      )}
    </div>
  );
};

export default Slider;
